export default __webpack_public_path__ + "1.19.4/static/media/link-arrow.a76636ac.svg";